// @ts-check
import React, { Component } from 'react';
import HForm, {
  TextField,
  PlainSelectField,
  MultiTreeSelectField,
} from 'shared/containers/portal_layout/HForm';
import { timeZoneOptions } from 'lib/TimeZones';
import LoadingContent from 'shared/components/LoadingContent';
import { inlineReduxForm } from 'utils/reduxFormWrapper';
import { Page, Row, Widget } from 'shared/containers/portal_layout';
import api from 'utils/api';
import { decamelizeKeys } from 'humps';
import { browserHistory } from 'react-router';
import Errors from 'shared/components/Errors';
import FlashMessageActions from 'shared/actions/FlashMessageActions';

const Wrapper = props => {
  return (
    <Page title="New Staff User">
      <Row>
        <Widget title="New Staff User" span={12}>
          <New {...props} />
        </Widget>
      </Row>
    </Page>
  );
};

export default Wrapper;

class New extends Component {
  constructor() {
    super();
    this.state = {
      entities: null,
      roles: null,
    };
    this.createOrganizationUser = this.createOrganizationUser.bind(this);
  }

  componentDidMount() {
    this.fetchRoles();
    this.fetchEntities();
  }

  createOrganizationUser(formValues) {
    return api
      .post(
        `/agent_portal/api/current_employment/staff_organization_users`,
        decamelizeKeys(formValues)
      )
      .then(response => {
        FlashMessageActions.flashSuccess({ message: 'You have successfully created a user' });
        browserHistory.push(`/a/portal/organizations/${this.props.params.organization_id}/users`);
        return null;
      });
  }

  fetchRoles() {
    api.get('/shared/api/roles').then(response => {
      this.setState({ roles: response.data });
    });
  }

  fetchEntities() {
    api.get(`/agent_portal/api/current_employment`).then(response => {
      this.setState({ entities: response.data.mappedEntities });
    });
  }

  render() {
    if (!this.state.roles || !this.state.entities) return <LoadingContent />;
    return inlineReduxForm({ form: 'createAgent' }, formProps => (
      <HForm
        onSubmit={formProps.handleSubmit(this.createOrganizationUser)}
        className="agent-creation"
      >
        <Errors errors={formProps.error || []} />
        <TextField name="firstName" label="First name" />
        <TextField name="lastName" label="Last name" />
        <TextField name="email" label="Email" />
        <PlainSelectField name="timeZoneName" label="Timezone" options={timeZoneOptions} />
        <PlainSelectField
          name="roleId"
          label="Role"
          options={this.state.roles}
          labelKey="name"
          valueKey="id"
        />
        <MultiTreeSelectField
          name="mappedEntityIds"
          label="Locations/Organizations"
          options={this.state.entities}
          subOptionsKey="children"
          valueKey="id"
          labelKey="name"
        />
        <button className="btn btn-primary" type="submit">
          Create Staff User
        </button>
      </HForm>
    ));
  }
}
